<template>
  <div class="view__ct">
    <div
      v-for="view in assessment.assessmentType.steps[assessment.step.index].views" :key="view.viewType.name"
      @click="assessment.setViewType(view.viewType, true)"
      :title="view.viewType.name? (view.viewType.name[0].toUpperCase() + view.viewType.name.slice(1).replace('-', ' ') + ' view'): ''"
      :class="{active: assessment.viewType == view.viewType}"
      class="view__item"
    >
        <img :src="iconUrl(view.viewType.icon)" alt />
    </div>
  </div>
</template>


<script>
import { assessment } from "@/services/assessment-model.js";
export default {
  name: "ViewMode",
  data() {
    return {
      assessment: assessment
    };
  },
  methods: {
    iconUrl(icon) {
      return require("../../assets/img/" + icon);
    }
  }
};
</script>

<style lang="scss" scoped>
.view {
  &__ct {
    overflow: hidden;
    background-color: grey;
    border: 1px sold #707070;
    border-bottom-left-radius: 10px;
    border-top-left-radius: 10px;
    background-color: #edebe5;
    margin-bottom: 20px;
  }

  &__item {
    cursor: pointer;
    padding-bottom: 10px;
    padding-top: 10px;
    padding-left: 15px;
    padding-right: 15px;
    img {
      width: 35px;
      height: 35px;
    }
    &.active, &:hover {
      background-color: white;
    }
  }
}
</style>
